

export const VALID_USERNAME_REGEX = /^[a-zA-Z0-9_-]*$/i;
export const usernameRegex = new RegExp(VALID_USERNAME_REGEX, 'i');

const validateUsername = (value, t) => {
  let fieldError = '';
  if (!value || value.length <= 1 || value.length > 30) {
    fieldError = t('username.validation.message');
  } else if (!usernameRegex.test(value)) {
    fieldError = t('username.format.validation.message');
  }
  return fieldError;
};

export default validateUsername;
